import StatusBadge from "../../components/StatusBadge";

const PaymentStatusBadge = ({ status }) => {
  if (status === "NOT_STARTED") {
    return <StatusBadge color="gray" title={"notStarted"} />;
  }
  if (status === "NOT_SENT") {
    return <StatusBadge color="orange" title={"notSent"} />;
  }
  if (status === "SENT") {
    return <StatusBadge color="gray" title={"sent"} />;
  }
  if (status === "PENDING") {
    return <StatusBadge color="blue" title={"inProgress"} />;
  }
  if (status === "REJECTED" || status === "INCOMPLETE") {
    return <StatusBadge color="red" title={"incomplete"} />;
  }

  if (status === "ACCEPTED") {
    return <StatusBadge color="green" title={"approved"} />;
  }

  if (status === "PAYMENT_CHECK_PENDING") {
    return <StatusBadge color="blue" title={"paymentCheckPending"} />;
  }

  if (status === "SENT_TO_POLICIES") {
    return <StatusBadge color="blue" title={"sentToPolicy"} />;
  }

  if (status === "PRIMARY_CHECK") {
    return <StatusBadge color="blue" title={"primaryCheck"} />;
  }

  return null;
};

export default PaymentStatusBadge;
